import "./SwipeableModals.scss";
import { useEffect, useState } from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import BlueButton from "../../../components/BlueButton/BlueButton";
import api from "../../../utils/api";

import { message } from "antd";
import dayjs from "dayjs";

const SwipeableModals = ({
  open,
  onClose,
  onOpen,
  currentView,
  onDataChange,
  coupon,
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    code: "",
    type: "percent",
    discount_amount: "",
    max_uses: "",
    max_uses_user: "1",
    start_date: null,
    end_date: null,
    max_discount: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (currentView === "editDiscountCode" && coupon) {
      setFormData({
        code: coupon.code || "",
        type: coupon.type || "percent",
        discount_amount: coupon.discount_amount || "",
        max_uses: coupon.max_uses || "",
        max_uses_user: coupon.max_uses_user || "1",
        start_date: coupon.start_date ? dayjs(coupon.start_date) : null,
        end_date: coupon.end_date ? dayjs(coupon.end_date) : null,
        max_discount: coupon.max_discount || "",
      });
    } else if (currentView === "createDiscountCode") {
      // Reset form when opening create view
      setFormData({
        code: "",
        type: "percent",
        discount_amount: "",
        max_uses: "",
        max_uses_user: "1",
        start_date: null,
        end_date: null,
        max_discount: "",
      });
    }
  }, [currentView, coupon]);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.code) {
      newErrors.code = "كود الخصم مطلوب";
    }
    if (!formData.discount_amount) {
      newErrors.discount_amount = "قيمة الخصم مطلوبة";
    } else if (
      formData.type === "percent" &&
      (formData.discount_amount < 0 || formData.discount_amount > 100)
    ) {
      newErrors.discount_amount = "النسبة يجب أن تكون بين 0 و 100";
    }
    if (!formData.max_uses) {
      newErrors.max_uses = "عدد مرات الاستخدام مطلوب";
    }
    if (!formData.start_date) {
      newErrors.start_date = "تاريخ البداية مطلوب";
    }
    if (!formData.end_date) {
      newErrors.end_date = "تاريخ الانتهاء مطلوب";
    }
    if (
      formData.end_date &&
      formData.start_date &&
      dayjs(formData.end_date).isBefore(formData.start_date)
    ) {
      newErrors.end_date = "تاريخ الانتهاء يجب أن يكون بعد تاريخ البداية";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      await api.post("/coupons", {
        ...formData,
        start_date: dayjs(formData.start_date).format("YYYY-MM-DD"),
        end_date: dayjs(formData.end_date).format("YYYY-MM-DD"),
      });

      message.success("تم إنشاء كود الخصم بنجاح");
      onDataChange?.();
      onClose();
      setFormData({
        code: "",
        type: "percent",
        discount_amount: "",
        max_uses: "",
        max_uses_user: "1",
        start_date: null,
        end_date: null,
        max_discount: "",
      });
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const renderCreateDiscountCodeView = () => (
    <div className="user-modal">
      <p className="user-modal-p">اضافة كود خصم</p>
      <form onSubmit={handleSubmit}>
        <FormControl
          sx={{ width: "100%" }}
          variant="outlined"
          error={!!errors.code}
        >
          <InputLabel
            htmlFor="code"
            shrink
            sx={{
              background: "white",
              transformOrigin: "right top",
              transform: "translate(14px, -9px) scale(0.75)",
              right: 24,
              left: "auto",
              paddingLeft: "4px",
              paddingRight: "4px",
            }}
          >
            رمز كود الخصم
          </InputLabel>
          <OutlinedInput
            name="code"
            value={formData.code}
            onChange={handleInputChange}
            sx={{ borderRadius: "8px" }}
            required
            type="text"
            notched
          />
          {errors.code && <FormHelperText error>{errors.code}</FormHelperText>}
        </FormControl>

        <FormControl
          sx={{
            width: "100%",
            border: "1px solid #DBDEE1",
            borderRadius: "8px",
            padding: "2px 12px",
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <span>نوع الكود</span>
          <RadioGroup
            row
            name="type"
            value={formData.type}
            onChange={handleInputChange}
          >
            <FormControlLabel
              value="percent"
              control={<Radio color="success" />}
              label="نسبة"
              sx={{ margin: 0 }}
            />
            <FormControlLabel
              value="fixed"
              control={<Radio color="success" />}
              label="قيمة"
              sx={{ margin: 0 }}
            />
          </RadioGroup>
        </FormControl>

        <FormControl
          sx={{ width: "100%" }}
          variant="outlined"
          error={!!errors.discount_amount}
        >
          <InputLabel
            htmlFor="discount_amount"
            shrink
            sx={{
              background: "white",
              transformOrigin: "right top",
              transform: "translate(14px, -9px) scale(0.75)",
              right: 24,
              left: "auto",
              paddingLeft: "4px",
              paddingRight: "4px",
            }}
          >
            {formData.type === "percent" ? "نسبة الخصم" : "قيمة الخصم"}
          </InputLabel>
          <OutlinedInput
            name="discount_amount"
            value={formData.discount_amount}
            onChange={handleInputChange}
            sx={{ borderRadius: "8px" }}
            required
            type="number"
            notched
          />
          {errors.discount_amount && (
            <FormHelperText error>{errors.discount_amount}</FormHelperText>
          )}
        </FormControl>

        {formData.type === "percent" && (
          <FormControl sx={{ width: "100%" }} variant="outlined">
            <InputLabel
              htmlFor="max_discount"
              shrink
              sx={{
                background: "white",
                transformOrigin: "right top",
                transform: "translate(14px, -9px) scale(0.75)",
                right: 24,
                left: "auto",
                paddingLeft: "4px",
                paddingRight: "4px",
              }}
            >
              الحد الاقصي للخصم
            </InputLabel>
            <OutlinedInput
              name="max_discount"
              value={formData.max_discount}
              onChange={handleInputChange}
              sx={{ borderRadius: "8px" }}
              type="number"
              notched
            />
          </FormControl>
        )}

        <FormControl
          sx={{ width: "100%" }}
          variant="outlined"
          error={!!errors.max_uses}
        >
          <InputLabel
            htmlFor="max_uses"
            shrink
            sx={{
              background: "white",
              transformOrigin: "right top",
              transform: "translate(14px, -9px) scale(0.75)",
              right: 24,
              left: "auto",
              paddingLeft: "4px",
              paddingRight: "4px",
            }}
          >
            عدد مرات الاستخدام
          </InputLabel>
          <OutlinedInput
            name="max_uses"
            value={formData.max_uses}
            onChange={handleInputChange}
            sx={{ borderRadius: "8px" }}
            required
            type="number"
            notched
          />
          {errors.max_uses && (
            <FormHelperText error>{errors.max_uses}</FormHelperText>
          )}
        </FormControl>

        <div className="control-group">
          <FormControl
            sx={{ width: "100%" }}
            error={!!errors.start_date}
          >
            <InputLabel
              htmlFor="start_date"
              shrink
              sx={{
                background: "white",
                transformOrigin: "right top",
                transform: "translate(14px, -9px) scale(0.75)",
                right: 24,
                left: "auto",
                paddingLeft: "4px",
                paddingRight: "4px",
              }}
            >
              تاريخ البداية
            </InputLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={formData.start_date}
                onChange={(newValue) => {
                  setFormData((prev) => ({ ...prev, start_date: newValue }));
                  if (errors.start_date) {
                    setErrors((prev) => ({ ...prev, start_date: "" }));
                  }
                }}
                sx={{ width: "100%" }}
              />
            </LocalizationProvider>
            {errors.start_date && (
              <FormHelperText error>{errors.start_date}</FormHelperText>
            )}
          </FormControl>

          <FormControl
            sx={{ width: "100%" }}
            error={!!errors.end_date}
          >
            <InputLabel
              htmlFor="end_date"
              shrink
              sx={{
                background: "white",
                transformOrigin: "right top",
                transform: "translate(14px, -9px) scale(0.75)",
                right: 24,
                left: "auto",
                paddingLeft: "4px",
                paddingRight: "4px",
              }}
            >
              تاريخ الانتهاء
            </InputLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={formData.end_date}
                onChange={(newValue) => {
                  setFormData((prev) => ({ ...prev, end_date: newValue }));
                  if (errors.end_date) {
                    setErrors((prev) => ({ ...prev, end_date: "" }));
                  }
                }}
                sx={{ width: "100%" }}
              />
            </LocalizationProvider>
            {errors.end_date && (
              <FormHelperText error>{errors.end_date}</FormHelperText>
            )}
          </FormControl>
        </div>

        <BlueButton
          text="اضافة"
          size="medium"
          variant="fill"
          type="submit"
          loading={loading}
        />
      </form>
    </div>
  );

  const renderEditDiscountCodeView = () => {
    const handleEditSubmit = async (e) => {
      e.preventDefault();
      if (!validateForm()) return;
      setLoading(true);

      try {
        // Format dates
        const formattedData = {
          ...formData,
          start_date: dayjs(formData.start_date).format("YYYY-MM-DD"),
          end_date: dayjs(formData.end_date).format("YYYY-MM-DD"),
        };

        // Convert to x-www-form-urlencoded format
        const params = new URLSearchParams();
        for (const key in formattedData) {
          params.append(key, formattedData[key]);
        }

        // Send request with the correct content type
        await api.put(`/coupons/${coupon.id}`, params, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });

        message.success("تم تعديل كود الخصم بنجاح");
        onDataChange?.();
        onClose();
      } catch (error) {
        // Error handling
      } finally {
        setLoading(false);
      }
    };

    return (
      <div className="user-modal">
        <p className="user-modal-p">تعديل كود الخصم</p>
        <form onSubmit={handleEditSubmit}>
          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            error={!!errors.code}
          >
            <InputLabel
              htmlFor="code"
              shrink
              sx={{
                background: "white",
                transformOrigin: "right top",
                transform: "translate(14px, -9px) scale(0.75)",
                right: 24,
                left: "auto",
                paddingLeft: "4px",
                paddingRight: "4px",
              }}
            >
              رمز كود الخصم
            </InputLabel>
            <OutlinedInput
              name="code"
              value={formData.code}
              onChange={handleInputChange}
              sx={{ borderRadius: "8px" }}
              required
              type="text"
              notched
            />
            {errors.code && (
              <FormHelperText error>{errors.code}</FormHelperText>
            )}
          </FormControl>

          <FormControl
            sx={{
              width: "100%",
              border: "1px solid #DBDEE1",
              borderRadius: "8px",
              padding: "2px 12px",
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <span>نوع الكود</span>
            <RadioGroup
              row
              name="type"
              value={formData.type}
              onChange={handleInputChange}
            >
              <FormControlLabel
                value="percent"
                control={<Radio color="success" />}
                label="نسبة"
                sx={{ margin: 0 }}
              />
              <FormControlLabel
                value="fixed"
                control={<Radio color="success" />}
                label="قيمة"
                sx={{ margin: 0 }}
              />
            </RadioGroup>
          </FormControl>

          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            error={!!errors.discount_amount}
          >
            <InputLabel
              htmlFor="discount_amount"
              shrink
              sx={{
                background: "white",
                transformOrigin: "right top",
                transform: "translate(14px, -9px) scale(0.75)",
                right: 24,
                left: "auto",
                paddingLeft: "4px",
                paddingRight: "4px",
              }}
            >
              {formData.type === "percent" ? "نسبة الخصم" : "قيمة الخصم"}
            </InputLabel>
            <OutlinedInput
              name="discount_amount"
              value={formData.discount_amount}
              onChange={handleInputChange}
              sx={{ borderRadius: "8px" }}
              required
              type="number"
              notched
            />
            {errors.discount_amount && (
              <FormHelperText error>{errors.discount_amount}</FormHelperText>
            )}
          </FormControl>

          {formData.type === "percent" && (
            <FormControl sx={{ width: "100%" }} variant="outlined">
              <InputLabel
                htmlFor="max_discount"
                shrink
                sx={{
                  background: "white",
                  transformOrigin: "right top",
                  transform: "translate(14px, -9px) scale(0.75)",
                  right: 24,
                  left: "auto",
                  paddingLeft: "4px",
                  paddingRight: "4px",
                }}
              >
                الحد الاقصي للخصم
              </InputLabel>
              <OutlinedInput
                name="max_discount"
                value={formData.max_discount}
                onChange={handleInputChange}
                sx={{ borderRadius: "8px" }}
                type="number"
                notched
              />
            </FormControl>
          )}

          <FormControl
            sx={{ width: "100%" }}
            variant="outlined"
            error={!!errors.max_uses}
          >
            <InputLabel
              htmlFor="max_uses"
              shrink
              sx={{
                background: "white",
                transformOrigin: "right top",
                transform: "translate(14px, -9px) scale(0.75)",
                right: 24,
                left: "auto",
                paddingLeft: "4px",
                paddingRight: "4px",
              }}
            >
              عدد مرات الاستخدام
            </InputLabel>
            <OutlinedInput
              name="max_uses"
              value={formData.max_uses}
              onChange={handleInputChange}
              sx={{ borderRadius: "8px" }}
              required
              type="number"
              notched
            />
            {errors.max_uses && (
              <FormHelperText error>{errors.max_uses}</FormHelperText>
            )}
          </FormControl>

          <div className="control-group">
            <FormControl
              sx={{
                width: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
              error={!!errors.start_date}
            >
              <InputLabel
                htmlFor="start_date"
                shrink
                sx={{
                  background: "white",
                  transformOrigin: "right top",
                  transform: "translate(14px, -9px) scale(0.75)",
                  right: 24,
                  left: "auto",
                  paddingLeft: "4px",
                  paddingRight: "4px",
                }}
              >
                تاريخ البداية
              </InputLabel>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={["DatePicker"]}
                  sx={{ p: 0, width: "100%" }}
                >
                  <DatePicker
                    value={formData.start_date}
                    onChange={(newValue) => {
                      setFormData((prev) => ({
                        ...prev,
                        start_date: newValue,
                      }));
                      if (errors.start_date) {
                        setErrors((prev) => ({ ...prev, start_date: "" }));
                      }
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              {errors.start_date && (
                <FormHelperText error>{errors.start_date}</FormHelperText>
              )}
            </FormControl>

            <FormControl
              sx={{
                width: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
              error={!!errors.end_date}
            >
              <InputLabel
                htmlFor="end_date"
                shrink
                sx={{
                  background: "white",
                  transformOrigin: "right top",
                  transform: "translate(14px, -9px) scale(0.75)",
                  right: 24,
                  left: "auto",
                  paddingLeft: "4px",
                  paddingRight: "4px",
                }}
              >
                تاريخ الانتهاء
              </InputLabel>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={["DatePicker"]}
                  sx={{ p: 0, width: "100%" }}
                >
                  <DatePicker
                    value={formData.end_date}
                    onChange={(newValue) => {
                      setFormData((prev) => ({ ...prev, end_date: newValue }));
                      if (errors.end_date) {
                        setErrors((prev) => ({ ...prev, end_date: "" }));
                      }
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              {errors.end_date && (
                <FormHelperText error>{errors.end_date}</FormHelperText>
              )}
            </FormControl>
          </div>

          <BlueButton
            text="تعديل"
            size="medium"
            variant="fill"
            type="submit"
            loading={loading}
          />
        </form>
      </div>
    );
  };

  const renderDefaultView = () => <div></div>;

  const views = {
    createDiscountCode: renderCreateDiscountCodeView,
    editDiscountCode: renderEditDiscountCodeView,
  };

  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      sx={{ zIndex: "1202" }}
      disableScrollLock
    >
      {(views[currentView] || renderDefaultView)()}
    </SwipeableDrawer>
  );
};

export default SwipeableModals;
